/**
 * Documentation: http://project-osrm.org/docs/v5.24.0/api/#
 */
export default {
  GEOJSON_PARAMS: 'overview=full&geometries=geojson',
  ROUTE_SERVICE: 'route/v1/driving',
};
